import { z } from 'zod';

export const metricLogSchema = z.object({
  dailySummary: z
    .object({
      assetID: z.string().min(1),
      jsonTimestamp: z.string().min(1),
    })
    .passthrough(),
});

export const metricLogsSchema = z.array(metricLogSchema);

export const metricLogResponseSchema = z.array(
  z.object({
    externalId: z.string().min(1),
    logs: z.array(metricLogSchema),
  })
);

export type MetricLogResponse = z.infer<typeof metricLogResponseSchema>;

export type MetricLog = z.infer<typeof metricLogSchema>;

export type MetricLogs = z.infer<typeof metricLogsSchema>;
